module.exports = __webpack_public_path__ + "static/businessPersonAvatar-e93811dd55f0dabb662c3e5c94d5daa0.png";